"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Base = /** @class */ (function () {
    function Base(_a) {
        var canvas = _a.canvas, config = _a.config, editor = _a.editor, state = _a.state;
        this.canvas = canvas;
        this.config = config;
        this.editor = editor;
        this.state = state;
    }
    return Base;
}());
exports.default = Base;
//# sourceMappingURL=Base.js.map